if (!customElements.get('morning-ritual-atc')) {
  customElements.define(
    'morning-ritual-atc',
    class MorningRitualAtc extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('[data-morning-ritual-atc-button]');
        this.notice = this.querySelector('.ajax-add-notice');
        this.cart = document.querySelector('cart-drawer');
        this.error = false;

        if (!this.button) return;

        if (this.cart) {
          this.button.setAttribute('aria-haspopup', 'dialog');
        }

        this.button.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        event.preventDefault();

        if (this.button.getAttribute('aria-disabled') === 'true' || this.button.disabled) return;

        const variantIds = (this.button.dataset.variantIds || '')
          .split(',')
          .map((id) => parseInt(id, 10))
          .filter((id) => Number.isInteger(id) && id > 0);

        if (!variantIds.length) return;

        this.error = false;
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');

        const payload = {
          items: variantIds.map((id) => ({
            id,
            quantity: 1,
          })),
        };

        if (this.cart?.getSectionsToRender) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        const config = fetchConfig('json');
        config.body = JSON.stringify(payload);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.error = true;
              console.error(response.description || response.message);
              return;
            }

            document.dispatchEvent(
              new CustomEvent('product:added-to-cart', {
                bubbles: true,
                detail: { response },
              })
            );

            if (!this.cart) {
              return;
            }

            this.cart.setActiveElement(this.button);
            this.cart.renderContents(response);
            this.notice?.classList.remove('hidden');
            document.querySelector('.ajax-add-notice')?.classList.remove('hidden');
          })
          .catch((error) => {
            this.error = true;
            console.error(error);
          })
          .finally(() => {
            this.button.classList.remove('loading');

            if (this.cart?.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.button.removeAttribute('aria-disabled');
            }
          });
      }
    }
  );
}